/*
 * File: VitalsModel.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: MST model for an for vitals in clinical
 */
import { types, getSnapshot, flow } from "mobx-state-tree";
import VitalsApi from "../Api";
import VitalsDataModel from "./VitalsDataModel";
import DateFormatter from "utils/DateFormatter";
const VitalsModel = types
  .model("VitalsModel", VitalsDataModel)

  .actions(self => ({
    changeField(key, val) {
      self[key] = val;
    },

    preSave() {
      self.convertHeight();
      self.convertWeight();
      self.convertHeadCircumference();
    },

    convertHeight() {
      const inchesInFeet = self.inches / 12;
      const totalFeet = self.feet + inchesInFeet;
      self.height = totalFeet * 304.8;
    },

    convertWeight() {
      const weightInGrams = Math.floor(self.weight * 453.592);
      self.weight = weightInGrams;
    },

    convertHeadCircumference() {
      const circumferenceInMillimeters = self.headCircumference * 10;
      self.headCircumference = circumferenceInMillimeters;
    },

    fetchVitals: flow(function*(vitalsId) {
      try {
        return yield VitalsApi.getVitalsDetails(vitalsId);
      } catch (error) {
        console.error("Error fetching vitals record", error);
      }
    }),

    saveNewVitals: flow(function*(patientId) {
      self.preSave();
      try {
        let snapshot = Object.assign({}, getSnapshot(self));
        snapshot.date = DateFormatter.forApi(new Date(snapshot.date));
        return yield VitalsApi.postVitals(patientId, snapshot);
      } catch (error) {
        console.error("Error adding new vitals", error);
      }
    })
  }))

  .views(self => ({
    validateFullForm(formStore) {
      if (
        !self.feet &&
        !self.inches &&
        !self.weight &&
        !self.systolic &&
        !self.diastolic &&
        !self.heartRate &&
        !self.temperature &&
        !self.sp02 &&
        !self.respiratoryRate &&
        !self.headCircumference
      )
        formStore.setFormError(
          "Empty Vitals",
          "At least one field in vitals other than Date Measured and Time Measured must be filled in."
        );
      else formStore.setFormError(undefined, undefined);
    }
  }));

export default VitalsModel;
